import React from 'react';
import PropTypes from 'prop-types';
import { Error } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import useStyles from '../shared/useStyles';
import styles from './styles';

const AppError = (props) => {
  const { type } = props;
  const classes = useStyles(styles);

  return (
    <div className={classes.container}>
      <Error className={classes.errorIcon} />
      <Typography className={classes.text}>
        It appears you have cookies disabled. This application relies on the use
        of cookies. If you wish to continue to use this application, please
        enable cookies in your browser settings.
        <br />
        <br />
        If you believe this an error, please contact us at:
        farmercoop@farmerscooperativeins.com
      </Typography>
    </div>
  );
};

AppError.propTypes = {
  type: PropTypes.string.isRequired,
};

export default AppError;
